<atlas-nav-item-container *ngIf="!!sideNavigationItem.sideNavigationContainer"
                          [icon]="sideNavigationItem.sideNavigationContainer.icon"
                          [translationId]="sideNavigationItem.sideNavigationContainer.translationId"
                          [logoUrl]="sideNavigationItem.sideNavigationContainer.logoUrl"
                          [label]="sideNavigationItem.sideNavigationContainer.label"
                          [indentation]="indentation"
                          [showIcon]="sideNavigationItem.sideNavigationContainer.showIcon"
                          [children]="sideNavigationItem.sideNavigationContainer.sideNavigationItems"
                          [chipContent]="sideNavigationItem.sideNavigationContainer.chipContent">
    <atlas-bc-nav-item *ngFor="let item of sideNavigationItem.sideNavigationContainer.sideNavigationItems"
                       [sideNavigationItem]="item" [indentation]="indentation + 1"></atlas-bc-nav-item>
</atlas-nav-item-container>

<atlas-nav-item-section *ngIf="!!sideNavigationItem.sideNavigationSection"
                        [translationId]="sideNavigationItem.sideNavigationSection.translationId"
                        [label]="sideNavigationItem.sideNavigationSection.label"
                        [chipContent]="sideNavigationItem.sideNavigationSection.chipContent"
                        [indentation]="indentation"
                        [startOpen]="true">
    <atlas-bc-nav-item *ngFor="let item of sideNavigationItem.sideNavigationSection.sideNavigationItems"
                       [sideNavigationItem]="item" [indentation]="indentation + 1"></atlas-bc-nav-item>
</atlas-nav-item-section>

<!-- End of recursion -->
<atlas-nav-item *ngIf="!!sideNavigationItem.sideNavigationLink"
                [url]="sideNavigationItem.sideNavigationLink.url"
                [path]="sideNavigationItem.sideNavigationLink.path"
                [icon]="sideNavigationItem.sideNavigationLink.icon"
                [label]="sideNavigationItem.sideNavigationLink.label"
                [translationId]="sideNavigationItem.sideNavigationLink.translationId"
                [logoUrl]="sideNavigationItem.sideNavigationLink.logoUrl"
                [serviceProviderId]="sideNavigationItem.sideNavigationLink.serviceProviderId"
                [navigationId]="sideNavigationItem.sideNavigationLink.navigationId"
                [indentation]="indentation"
                [showIcon]="sideNavigationItem.sideNavigationLink.showIcon"
                [pinnable]="sideNavigationItem.sideNavigationLink.pinnable"
                [chipContent]="sideNavigationItem.sideNavigationLink.chipContent"
                [userRequired]="sideNavigationItem.sideNavigationLink.userRequired">
</atlas-nav-item>
